export const GLOBAL_STATE = 'Letters'

// Legacy letter actions are disabled until the backend restores /letter/*.
// export const LETTER_CREATE = 'LETTER_CREATE'
// export const LETTER_DELETE = 'LETTER_DELETE'
// export const LETTER_INCOMING_LIST = 'LETTER_INCOMING_LIST'
// export const LETTER_OUTGOING_LIST = 'LETTER_OUTGOING_LIST'
// export const LETTER_STATUS = 'LETTER_STATUS'
// export const LETTER_PUBLIC_INFO = 'LETTER_PUBLIC_INFO'
export const EXTERNAL_LETTERS_LIST = 'EXTERNAL_LETTERS_LIST'
export const EXTERNAL_LETTER_REGISTER = 'EXTERNAL_LETTER_REGISTER'
export const EXTERNAL_LETTER_ITEM = 'EXTERNAL_LETTER_ITEM'
export const EXTERNAL_LETTER_DELETE = 'EXTERNAL_LETTER_DELETE'
export const EXTERNAL_LETTER_COMMENT_TEMPLATES = 'EXTERNAL_LETTER_COMMENT_TEMPLATES'
export const EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE = 'EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE'
export const EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE = 'EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE'
export const EXTERNAL_LETTER_SEND_TO_INFORM = 'EXTERNAL_LETTER_SEND_TO_INFORM'
export const EXTERNAL_LETTER_PROVIDE_RESOLUTION = 'EXTERNAL_LETTER_PROVIDE_RESOLUTION'
export const EXTERNAL_LETTER_CONFIRM_INFORMED = 'EXTERNAL_LETTER_CONFIRM_INFORMED'
export const EXTERNAL_LETTER_COMPLETE_EXECUTION = 'EXTERNAL_LETTER_COMPLETE_EXECUTION'
export const EXTERNAL_LETTER_REQUIRE_UPDATE = 'EXTERNAL_LETTER_REQUIRE_UPDATE'
export const EXTERNAL_LETTER_COMPLETE = 'EXTERNAL_LETTER_COMPLETE'
